import React from "react";
import { useEffect, useState } from "react";
import {
  GetAllShortlistCandidates,
  InterviewSchedule,
  SelectedCandidate,
  RejectedCandidates,
  viewResumeUrl,
  HoldCandidates,
  BackOutCandidate,
  SendAssessmentCandidate,
  StartBGV,
  SystemRemark,
  GetCandidateDetails,
} from "../../../services/candidateService";
import { getEmployeeSuggestions } from "../../../services/metadataService";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Modal, Button, Form, Toast, ToastContainer } from "react-bootstrap";
import NormalAlert from "../../AlertComponent/NormalAlert";
import { getEmployeeDetails } from "../../../services/metadataService";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ShortlistCandidates = () => {
  const [loading, setLoading] = useState(true);
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [modalType, setModalType] = useState("");
  const [remark, setRemark] = useState("");
  const [interviewID, setinterviewID] = useState("");
  const [interviewDateTime, setinterviewDateTime] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showJobTitleFilter, setShowJobTitleFilter] = useState(false);
  const [filteredTitles, setFilteredTitles] = useState([]);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [searchTitleText, setSearchTitleText] = useState("");
  const [status, setStatus] = useState("");
  const [submittedCandidateID, setSubmittedCandidateID] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [assessmentLink, setAssessmentLink] = useState("");
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeUrl, setResumeUrl] = useState(null);
  const [systemRemarkData, setSystemRemarkData] = useState(null);
  const [showSystemRemarkModal, setShowSystemRemarkModal] = useState(false);
  const [showSystemRemark, setShowSystemRemark] = useState(false);
  const [interviewType, setInterviewType] = useState("");
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [interviewerList, setInterviewerList] = useState([
    { interviewerCode: "", interviewSequence: 1, interviewerName: "" },
  ]);
  const [showAddInterviewer, setShowAddInterviewer] = useState(false);
  const [newInterviewer, setNewInterviewer] = useState({
    interviewerCode: "",
    interviewerName: "",
    interviewSequence: 1,
  });
  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "success",
  });
  const [isOpen, setIsOpen] = useState(true);
  const [isJobDetailsOpen, setIsJobDetailsOpen] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeField, setActiveField] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const totalRecords = candidates.length;

  useEffect(() => {
    const GetShortlistCandidates = async () => {
      try {
        const response = await GetAllShortlistCandidates();

        if (
          response?.data?.status === "Success" &&
          response?.data?.shortlistedCandidates
        ) {
          setCandidates(response.data.shortlistedCandidates);
        } else {
          setAlert({
            type: "fail",
            message:
              response?.data?.message || "No shortlisted candidates found.",
          });
          setCandidates([]);
        }
      } catch (error) {
        const backendMessage = error?.response?.data?.message;

        if (backendMessage !== "No candidate found.") {
          setAlert({
            type: "fail",
            message:
              backendMessage || "Something went wrong. Please try again.",
          });
        }

        setCandidates([]);
      } finally {
        setLoading(false);
      }
    };

    GetShortlistCandidates();
  }, []);

  const openModal = async (candidate, type) => {
    setSelectedCandidate(candidate);
    setModalType(type);
    setRemark("");
    setShowModal(true);

    try {
      const response = await GetCandidateDetails(
        candidate.submitedCandidateUID
      );

      // Store the candidate details for modal display
      setCandidateDetails(response.data);

      // Prefill interviewerList if jobInterviewers exist
      if (response.data.jobInterviewers?.length > 0) {
        const list = response.data.jobInterviewers.map((interviewer) => ({
          interviewerCode: interviewer.interviewerCode,
          interviewSequence: interviewer.interviewSequence,
          interviewerName: interviewer.interviewerName,
          interviewerEmail: interviewer.interviewerEmail,
        }));
        setInterviewerList(list);
      } else {
        // If no interviewers, initialize with empty default
        setInterviewerList([
          {
            interviewerCode: "",
            interviewSequence: 1,
            interviewerName: "",
            interviewerEmail: "",
          },
        ]);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setCandidateDetails(error.response.data);

        // Prefill interviewerList
        if (error.response.data.jobInterviewers?.length > 0) {
          const list = error.response.data.jobInterviewers.map(
            (interviewer) => ({
              interviewerCode: interviewer.interviewerCode,
              interviewSequence: interviewer.interviewSequence,
              interviewerName: interviewer.interviewerName,
              interviewerEmail: interviewer.interviewerEmail,
            })
          );
          setInterviewerList(list);
        } else {
          setInterviewerList([
            {
              interviewerCode: "",
              interviewSequence: 1,
              interviewerName: "",
              interviewerEmail: "",
            },
          ]);
        }
      }
    }
  };

  const jobTitles = [...new Set(candidates.map((c) => c.jobTitel))];

  const handleFilterIconClick = () => {
    setShowJobTitleFilter(true);
    setFilteredTitles(jobTitles);
    setSelectedTitles(jobTitles);
    setSearchTitleText("");
  };

  const handleSearchTitleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTitleText(value);
    setFilteredTitles(
      jobTitles.filter((title) => title.toLowerCase().includes(value))
    );
  };

  const handleSelectTitle = (title) => {
    if (selectedTitles.includes(title)) {
      setSelectedTitles(selectedTitles.filter((t) => t !== title));
    } else {
      setSelectedTitles([...selectedTitles, title]);
    }
  };

  const handleSelectAllTitles = (checked) => {
    setSelectedTitles(checked ? jobTitles : []);
  };

  const filteredCandidates = candidates.filter(
    (candidate) =>
      (selectedTitles.length === 0 ||
        selectedTitles.includes(candidate.jobTitel)) &&
      [
        candidate.name,
        candidate.jobTitel,
        candidate.email,
        candidate.mobile,
        candidate.submitedBy,
        candidate.submitByType,
      ].some((field) => field?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const hasCandidates = candidates.length > 0;
  const hasFilteredCandidates = filteredCandidates.length > 0;

  const [currentPage, setCurrentPage] = useState(1);
  const [candidatesPerPage, setCandidatesPerPage] = useState(10);
  const indexOfLastCandidate = currentPage * candidatesPerPage;
  const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
  const currentCandidates = filteredCandidates.slice(
    indexOfFirstCandidate,
    indexOfLastCandidate
  );
  const totalPages = Math.ceil(filteredCandidates.length / candidatesPerPage);
  const goToPage = (pageNumber) => setCurrentPage(pageNumber);
  const goToNext = () =>
    currentPage < totalPages && setCurrentPage((prev) => prev + 1);
  const goToPrev = () => currentPage > 1 && setCurrentPage((prev) => prev - 1);
  const formatCurrentDateTime = (dateObj) => {
    const formattedDate = `${dateObj.getFullYear()}/${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}/${String(dateObj.getDate()).padStart(2, "0")}`;
    const formattedTime = `${String(dateObj.getHours()).padStart(
      2,
      "0"
    )}:${String(dateObj.getMinutes()).padStart(2, "0")}`;
    return `${formattedDate} ${formattedTime}`;
  };

  const HandleInterviewScheduleCandidate = async () => {
    try {
      const formattedDateTime = interviewDateTime + ":00";

      const response = await InterviewSchedule(
        selectedCandidate.submitedCandidateUID,
        3,
        remark,
        formattedDateTime,
        interviewerList
      );

      if (response && response.data) {
        setAlert({
          type: response.data.status,
          message: response.data.message,
        });
        setShowModal(false);
      } else {
        setAlert({
          type: "fail",
          message: "Error! Please try again after some time.",
        });
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message: error?.response?.data?.message || "Unknown error occurred",
      });
    }
  };

  // For Rejected Candidate
  const HandleRejectedCandidate = () => {
    const Action = async () => {
      try {
        const response = await RejectedCandidates(
          selectedCandidate.submitedCandidateUID,
          7,
          remark
        );
        // if (response) {
        //   setAlert({ type: response.data.status, message: response.message });
        //   setShowModal(false );
        // }
        if (response?.data) {
          setAlert({
            type:
              response.data.status?.toLowerCase() === "success"
                ? "success"
                : "fail",
            message: response.data.message || "Action completed.",
          });
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({ type: "fail", message: error.response.data.message });
      }
    };
    Action();
  };

  // For Hold Candidate
  const HandleHoldCandidate = () => {
    const Action = async () => {
      try {
        const response = await HoldCandidates(
          selectedCandidate.submitedCandidateUID,
          8,
          remark
        );
        if (response) {
          setAlert({
            type: response.data.status,
            message: response.data.message,
          });
          setShowModal(false);
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({ type: "fail", message: error.response.data.message });
      }
    };
    Action();
  };

  // For Back out Candidate
  const HandleBackoutCandidate = () => {
    const Action = async () => {
      try {
        const response = await BackOutCandidate(
          selectedCandidate.submitedCandidateUID,
          10,
          remark
        );
        if (response) {
          setAlert({
            type: response.data.status,
            message: response.data.message,
          });
          setShowModal(false);
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({ type: "fail", message: error.response.data.message });
      }
    };
    Action();
  };

  // For Get System Remark
  const GetSystemRemark = () => {
    const Action = async () => {
      try {
        const response = await SystemRemark(
          selectedCandidate.submitedCandidateUID
        );
        if (response?.data?.status === "Success") {
          setSystemRemarkData(response.data.data);
          setShowSystemRemarkModal(true);
        } else {
          alert("Error Please Try After some time");
        }
      } catch (error) {
        setAlert({
          type: "fail",
          message: error?.response?.data?.message || "Something went wrong",
        });
      }
    };
    Action();
  };

  // handle button for System Remark
  const handleViewSystemRemark = () => {
    GetSystemRemark();
    setShowSystemRemark(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setShowSystemRemark(false);
    setSystemRemarkData(null);
  };

  // Open modal when clicking on candidate name
  const handleNameClick = async (candidate, type = null) => {
    setSelectedCandidate(candidate);
    setModalType(type);
    setRemark("");
    setShowModal(true);
    setCandidateDetails(null);

    try {
      const response = await GetCandidateDetails(
        candidate.submitedCandidateUID
      );
      setCandidateDetails(response.data);

      // Prefill interviewerList
      if (response.data.jobInterviewers?.length > 0) {
        const list = response.data.jobInterviewers.map((interviewer) => ({
          interviewerCode: interviewer.interviewerCode,
          interviewSequence: interviewer.interviewSequence,
          interviewerName: interviewer.interviewerName,
          interviewerEmail: interviewer.interviewerEmail,
        }));
        setInterviewerList(list);
      } else {
        setInterviewerList([
          {
            interviewerCode: "",
            interviewSequence: 1,
            interviewerName: "",
            interviewerEmail: "",
          },
        ]);
      }
    } catch (error) {
      // If API sends useful error data
      if (error.response?.data) {
        setCandidateDetails(error.response.data);

        if (error.response.data.jobInterviewers?.length > 0) {
          const list = error.response.data.jobInterviewers.map(
            (interviewer) => ({
              interviewerCode: interviewer.interviewerCode,
              interviewSequence: interviewer.interviewSequence,
              interviewerName: interviewer.interviewerName,
              interviewerEmail: interviewer.interviewerEmail,
            })
          );
          setInterviewerList(list);
        }
      }
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(interviewerList);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    // re-sequence after reorder
    const resequenced = items.map((it, i) => ({
      ...it,
      interviewSequence: String(i + 1),
    }));

    setInterviewerList(resequenced);
  };

  // Modal Open when Clicked on view resume
  const handleResumeModal = (candidate) => {
    setSelectedCandidate(candidate);

    if (candidate?.resumePath) {
      const fileName = candidate.resumePath.split("/").pop();
      const url = viewResumeUrl(fileName);
      setResumeUrl(url);
    } else {
      setResumeUrl(null);
    }

    setShowModal(false);
    setShowResumeModal(true);
  };

  return (
    <>
      <div className="jobs-container container mt-5 pt-5">
        <ToastContainer position="top-end" className="p-3">
          <Toast
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
            show={toast.show}
            delay={3000}
            autohide
          >
            <Toast.Body className="text-white fw-semibold">
              {toast.message}
            </Toast.Body>
          </Toast>
        </ToastContainer>
        <div className="jobs-card shadow-sm">
          <div className="jobs-header d-flex justify-content-between align-items-center">
            <h3 className="fw-bold mb-0">Shortlisted Candidates</h3>
          </div>

          {/* Search bar*/}
          <div className="jobs-toolbar d-flex flex-wrap align-items-center gap-3 my-3 w-100">
            <div
              className="input-group rounded-pill border bg-white shadow-sm"
              style={{ maxWidth: "350px" }}
            >
              <span className="input-group-text bg-transparent border-0 ps-3">
                <i className="bi bi-search text-secondary"></i>
              </span>
              <input
                type="text"
                className="form-control border-0 rounded-5 shadow-none"
                placeholder="Search by name, title etc"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="Overflow-Auto">
            {/* <div className="mt-5 table-responsive"> */}
            {loading ? (
              <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
                <table className="table modern-table align-middle">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        Job Title
                        <i
                          className="bi bi-funnel ms-2 text-primary"
                          onClick={handleFilterIconClick}
                          style={{ cursor: "pointer" }}
                        ></i>
                      </th>
                      <th>Submited By</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile Number</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(5)].map((_, idx) => (
                      <tr key={idx}>
                        {Array(7)
                          .fill()
                          .map((__, i) => (
                            <td key={i}>
                              <Skeleton height={20} />
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </SkeletonTheme>
            ) : (
              <table className="table modern-table align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      Job Title
                      <i
                        className="bi bi-funnel ms-2 text-primary"
                        onClick={handleFilterIconClick}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </th>
                    <th>Submited By</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCandidates.length > 0 ? (
                    currentCandidates.map((candidate, index) => (
                      <tr key={candidate.id || index}>
                        <td>{indexOfFirstCandidate + index + 1}</td>
                        <td>{candidate.jobTitel}</td>
                        <td>
                          {candidate.submitedBy}({candidate.submitByType})
                        </td>
                        <td>
                          <span
                            onClick={() => handleNameClick(candidate)}
                            className="text-primary fw-semibold"
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                          >
                            {candidate.name || "-"}
                          </span>
                        </td>
                        <td>{candidate.email || "-"}</td>
                        <td>{candidate.mobile || "-"}</td>
                        <td style={{ fontSize: "1.5em" }}>
                          <i
                            className="bi bi-file-earmark-text text-primary"
                            onClick={() => {
                              if (candidate.resumePath) {
                                const fileName = candidate.resumePath
                                  .split("/")
                                  .pop();
                                const url = viewResumeUrl(fileName);
                                setResumeUrl(url);
                                setShowResumeModal(true);
                              } else {
                                alert("Resume not available.");
                              }
                            }}
                          ></i>
                          <div className="dropdown d-inline mx-3 position-relative">
                            <style>{`
                           .table-responsive {
                            overflow: visible !important;
                           }
                         .table-responsive .dropdown-menu {
                               z-index: 9999;
                               position: absolute !important;
                               transform: translate(0, 0) !important;
                               will-change: transform;
                            }
                           `}</style>

                            <i
                              className="bi bi-three-dots-vertical"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            ></i>
                            <ul className="dropdown-menu">
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "InterviewScheduled")
                                  }
                                >
                                  Schedule Interview
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "RejectedCandidate")
                                  }
                                >
                                  Reject
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "HoldCandidate")
                                  }
                                >
                                  Hold
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    openModal(candidate, "BackoutCandidate")
                                  }
                                >
                                  Back-out
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-danger py-3">
                        {hasCandidates
                          ? "No Candidate Found."
                          : "No Candidate Found."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {totalRecords > 10 && (
            <div className="d-flex justify-content-end align-items-center mt-3 gap-3">
              <div className="d-flex align-items-center">
                <label className="me-2 fw-semibold">Items Per Page:</label>
                <Form.Select
                  className="form-select form-select-sm w-auto"
                  value={candidatesPerPage}
                  onChange={(e) => {
                    setCandidatesPerPage(parseInt(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Select>
              </div>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      <i class="bi bi-chevron-left"></i>
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${
                        currentPage === idx + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(idx + 1)}
                      >
                        {idx + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {/* Job Title Filter Modal */}
          <Modal
            show={showJobTitleFilter}
            onHide={() => setShowJobTitleFilter(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Filter by Job Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Control
                type="text"
                placeholder="Search Job Titles"
                value={searchTitleText}
                onChange={handleSearchTitleChange}
                className="mb-2"
              />
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedTitles.length === jobTitles.length}
                  onChange={(e) => handleSelectAllTitles(e.target.checked)}
                />
                <label className="form-check-label">Select All</label>
              </div>
              {filteredTitles.map((title, idx) => (
                <div className="form-check" key={idx}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedTitles.includes(title)}
                    onChange={() => handleSelectTitle(title)}
                    id={`job-title-${idx}`}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`job-title-${idx}`}
                  >
                    {title}
                  </label>
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>

      {/* Resume View Modal */}
      <Modal
        show={showResumeModal}
        onHide={() => {
          setShowResumeModal(false);
          setShowModal(true);
        }}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Candidate Resume</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          {resumeUrl ? (
            <iframe
              src={resumeUrl}
              title="Resume"
              style={{ width: "100%", height: "100%", border: "none" }}
            ></iframe>
          ) : (
            <p>Resume not available.</p>
          )}
        </Modal.Body>
      </Modal>

      {/* --modal-- */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Candidate and Job Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {candidateDetails ? (
            <>
              {/* Candidate Info */}
              <div className="card mb-4 shadow-sm p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Candidate Name */}
                  <h5 className="mb-0 text-uppercase text-primary">
                    {candidateDetails.candidateDetails?.name || "-"}
                  </h5>

                  <div className="d-flex align-items-center gap-2">
                    {/* Resume Button */}
                    {candidateDetails.candidateDetails?.resumePath ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          handleResumeModal(candidateDetails.candidateDetails)
                        }
                      >
                        <i className="bi bi-file-earmark-text me-1"></i> View
                        Resume
                      </button>
                    ) : (
                      <span className="text-muted small">NA</span>
                    )}

                    {/* Collapse/Expand Toggle */}
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      {isOpen ? (
                        <i className="bi bi-chevron-up"></i> // collapse icon
                      ) : (
                        <i className="bi bi-chevron-down"></i> // expand icon
                      )}
                    </button>
                  </div>
                </div>

                {isOpen && (
                  <>
                    <hr />
                    <div className="card-body">
                      {/* Other fields in 3 columns */}
                      <div className="row g-3">
                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-telephone text-info me-1"></i>
                            Mobile
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails?.mobile ||
                              "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-envelope text-info me-1"></i>
                            Email
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails?.email || "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-cash-stack text-info me-1"></i>
                            Current CTC
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails?.currentCTC ||
                              "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-graph-up text-info me-1"></i>
                            Expected CTC
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails?.expectedCTC ||
                              "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-briefcase text-info me-1"></i>
                            Total Experience
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails
                              ?.totalExperience || "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-geo-alt text-info me-1"></i>
                            Current Location
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails
                              ?.currentLocation || "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-calendar-check text-info me-1"></i>
                            Notice Period
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails?.noticePeriod ||
                              "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-chat-dots text-info me-1"></i>
                            Reason for Leaving
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails
                              ?.reasonofLeaving || "-NA-"}
                          </span>
                        </div>

                        <div className="col-md-4 col-12">
                          <p className="text-muted small mb-0">
                            <i className="bi bi-airplane text-info me-1"></i>
                            Ready to Relocate
                          </p>
                          <span className="fw-semibold small">
                            {candidateDetails.candidateDetails
                              ?.readytoRelocate || "-NA-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Job Info */}
              <div className="card mb-4 shadow-sm p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Job Title */}
                  <h5 className="mb-0 text-uppercase text-primary">
                    {candidateDetails.jobDetails?.jobTitel || "-"}
                  </h5>

                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => setIsJobDetailsOpen(!isJobDetailsOpen)}
                  >
                    <i
                      className={`bi ${
                        isJobDetailsOpen ? "bi-chevron-up" : "bi-chevron-down"
                      }`}
                    ></i>
                  </button>
                </div>

                <hr></hr>
                {isJobDetailsOpen && (
                  <div className="card-body">
                    {/* Other fields in 3 columns */}
                    <div className="row g-3">
                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-diagram-3 text-info me-1"></i>
                          Function Name
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.functionName || "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-building text-info me-1"></i>
                          Department
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.department || "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-award text-info me-1"></i>
                          Grade
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.grade || "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-hourglass-split text-info me-1"></i>
                          Minimum Experience
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.minimumExperience ||
                            "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-geo-alt text-info me-1"></i>
                          Zone
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.zone || "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-geo-alt text-info me-1"></i>
                          Location
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.location || "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-gender-ambiguous text-info me-1"></i>
                          Gender Preference
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.genderPreference ||
                            "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-cash-stack text-info me-1"></i>
                          Offered Salary
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.offeredSalary || "-NA-"}
                        </span>
                      </div>

                      <div className="col-md-4 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-mortarboard text-info me-1"></i>
                          Minimum Qualification
                        </p>
                        <span className="fw-semibold small">
                          {candidateDetails.jobDetails?.minimumQualification ||
                            "-NA-"}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Interviewers Info*/}
              {interviewerList.length > 0 && (
                <div className="card mb-4 shadow-sm">
                  <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Interviewers</h5>
                    <button
                      className="btn btn-light btn-sm"
                      onClick={() => setShowAddInterviewer(true)}
                    >
                      + Add Interviewer
                    </button>
                  </div>
                  <div className="card-body">
                    <DragDropContext onDragEnd={handleDragEnd}>
                      <table className="table table-bordered table-sm text-center mb-0">
                        <thead className="table-primary">
                          <tr>
                            <th style={{ width: 90 }}>Code</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th style={{ width: 110 }}>Sequence</th>
                            <th style={{ width: 110 }}>Action</th>
                          </tr>
                        </thead>

                        <Droppable
                          droppableId="interviewers"
                          renderClone={(provided, snapshot, rubric) => {
                            const interviewer =
                              interviewerList[rubric.source.index];
                            return (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className="table-active"
                                style={{
                                  ...provided.draggableProps.style,
                                  cursor: "grab",
                                }}
                              >
                                <td>{interviewer.interviewerCode}</td>
                                <td>{interviewer.interviewerName || "-"}</td>
                                <td>{interviewer.interviewerEmail || "-"}</td>
                                <td>{interviewer.interviewSequence}</td>
                                <td></td>
                              </tr>
                            );
                          }}
                        >
                          {(dropProvided) => (
                            <tbody
                              ref={dropProvided.innerRef}
                              {...dropProvided.droppableProps}
                            >
                              {interviewerList.map((interviewer, idx) => {
                                const dragId = String(
                                  interviewer.interviewerCode ?? `row-${idx}`
                                );
                                return (
                                  <Draggable
                                    key={dragId}
                                    draggableId={dragId}
                                    index={idx}
                                  >
                                    {(dragProvided, snapshot) => (
                                      <tr
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        {...dragProvided.dragHandleProps}
                                        className={
                                          snapshot.isDragging
                                            ? "table-active"
                                            : ""
                                        }
                                        style={{
                                          ...dragProvided.draggableProps.style,
                                          cursor: "grab",
                                        }}
                                      >
                                        <td>{interviewer.interviewerCode}</td>
                                        <td>
                                          {interviewer.interviewerName || "-"}
                                        </td>
                                        <td>
                                          {interviewer.interviewerEmail || "-"}
                                        </td>
                                        <td>{interviewer.interviewSequence}</td>
                                        <td>
                                          <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => {
                                              const updated = [
                                                ...interviewerList,
                                              ];
                                              updated.splice(idx, 1);
                                              const reseq = updated.map(
                                                (it, i) => ({
                                                  ...it,
                                                  interviewSequence: String(
                                                    i + 1
                                                  ),
                                                })
                                              );
                                              setInterviewerList(reseq);
                                            }}
                                          >
                                            Delete
                                          </button>
                                        </td>
                                      </tr>
                                    )}
                                  </Draggable>
                                );
                              })}
                              {dropProvided.placeholder}
                            </tbody>
                          )}
                        </Droppable>
                      </table>
                    </DragDropContext>
                  </div>
                </div>
              )}

              {/* For Interview Scheduled Modal */}
              {modalType === "InterviewScheduled" && (
                <div className="p-3 rounded shadow-sm border bg-light">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Do you want to schedule interview for this candidate?
                  </h6>

                  {/* Interview Date & Time */}
                  <input
                    type="datetime-local"
                    className="form-control w-50 mt-2"
                    value={interviewDateTime}
                    min={new Date().toISOString().slice(0, 16)}
                    onChange={(e) => setinterviewDateTime(e.target.value)}
                  />

                  {/* Remark */}
                  <textarea
                    placeholder="Enter remark..."
                    className="form-control mt-2"
                    style={{ minHeight: "80px", resize: "none" }}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="px-3 border-0 btn-primary rounded-pill shadow-sm"
                      onClick={HandleInterviewScheduleCandidate}
                    >
                      Schedule Interview
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 rounded-pill"
                      onClick={() => setShowModal(false)}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </div>
                </div>
              )}

              {/* For Rejected Candidate Modal */}
              {modalType === "RejectedCandidate" && (
                <div className="p-3 rounded shadow-sm border bg-light">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Do you want to reject this candidate?
                  </h6>
                  <textarea
                    placeholder="Enter Remark"
                    className="form-control mt-2"
                    style={{ minHeight: "80px", resize: "none" }}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="px-3 border-0 btn-primary rounded-pill shadow-sm"
                      onClick={HandleRejectedCandidate}
                    >
                      Reject
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 rounded-pill"
                      onClick={() => setShowModal(false)}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </div>
                </div>
              )}

              {/* For Hold Candidate Modal */}
              {modalType === "HoldCandidate" && (
                <div className="p-3 rounded shadow-sm border bg-light">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Do you want to Hold this candidate?
                  </h6>
                  <textarea
                    placeholder="Enter Remark"
                    className="form-control"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="px-3 border-0 btn-primary rounded-pill shadow-sm"
                      onClick={HandleHoldCandidate}
                    >
                      Hold
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 rounded-pill"
                      onClick={() => setShowModal(false)}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </div>
                </div>
              )}

              {/* For Back-out Candidate Modal */}
              {modalType === "BackoutCandidate" && (
                <div className="p-3 rounded shadow-sm border bg-light">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Do you want to Back-out this candidate?
                  </h6>
                  <textarea
                    placeholder="Enter Remark"
                    className="form-control"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="px-3 border-0 btn-primary rounded-pill shadow-sm"
                      onClick={HandleBackoutCandidate}
                    >
                      Back-out
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 rounded-pill"
                      onClick={() => setShowModal(false)}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
            </>
          ) : (
            <p>No candidate data available.</p>
          )}
        </Modal.Body>
      </Modal>
      {/* --end modal-- */}

      {/* Add Interview Modal */}
      <Modal
        show={showAddInterviewer}
        onHide={() => {
          setShowAddInterviewer(false);
          setShowModal(true); // reopen main modal
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Interviewer</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3 position-relative">
            <label className="form-label">Interviewer</label>
            <input
              type="text"
              className="form-control"
              value={newInterviewer.inputValue || ""}
              onChange={async (e) => {
                const input = e.target.value;

                // Update raw input
                setNewInterviewer((prev) => ({
                  ...prev,
                  inputValue: input,
                  interviewerCode: "",
                  interviewerName: "",
                }));

                if (input.trim().length > 1) {
                  const res = await getEmployeeSuggestions(input);
                  setSuggestions(res);
                  setShowSuggestions(true);
                  setActiveField("interviewerCode");
                } else {
                  setShowSuggestions(false);
                }
              }}
              onKeyDown={(e) => {
                if (!showSuggestions || suggestions.length === 0) return;

                if (e.key === "ArrowDown") {
                  e.preventDefault();
                  setHighlightedIndex((prev) =>
                    prev < suggestions.length - 1 ? prev + 1 : 0
                  );
                } else if (e.key === "ArrowUp") {
                  e.preventDefault();
                  setHighlightedIndex((prev) =>
                    prev > 0 ? prev - 1 : suggestions.length - 1
                  );
                } else if (e.key === "Enter") {
                  e.preventDefault();
                  if (
                    highlightedIndex >= 0 &&
                    highlightedIndex < suggestions.length
                  ) {
                    const s = suggestions[highlightedIndex];
                    setNewInterviewer((prev) => ({
                      ...prev,
                      interviewerCode: s.employeeCode,
                      interviewerName: s.employeeName,
                      interviewerEmail: s.employeeEmail,
                      inputValue: `${s.employeeCode} - ${s.employeeName}`,
                    }));
                    setShowSuggestions(false);
                    setHighlightedIndex(-1);
                  }
                }
              }}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              placeholder="Enter Interviewer Code or Name"
              autoComplete="off"
            />

            {/* Suggestions dropdown */}
            {showSuggestions &&
              activeField === "interviewerCode" &&
              suggestions.length > 0 && (
                <ul
                  className="list-group position-absolute w-100"
                  style={{ zIndex: 2000 }}
                >
                  {suggestions.map((s, idx) => (
                    <li
                      key={idx}
                      className={`list-group-item list-group-item-action ${
                        highlightedIndex === idx ? "active" : ""
                      }`}
                      onClick={() => {
                        setNewInterviewer((prev) => ({
                          ...prev,
                          interviewerCode: s.employeeCode,
                          interviewerName: s.employeeName,
                          interviewerEmail: s.employeeEmail,
                          inputValue: `${s.employeeCode} - ${s.employeeName}`,
                        }));
                        setShowSuggestions(false);
                        setHighlightedIndex(-1);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {s.employeeCode} - {s.employeeName}
                    </li>
                  ))}
                </ul>
              )}
          </div>

          {/* Interview Round */}
          <div className="mb-3">
            <label className="form-label">Interview Round</label>
            <input
              type="number"
              min="1"
              className="form-control"
              value={newInterviewer.interviewSequence}
              onChange={(e) =>
                setNewInterviewer((prev) => ({
                  ...prev,
                  interviewSequence: Number(e.target.value),
                }))
              }
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowAddInterviewer(false);
              setShowModal(true);
            }}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              if (
                newInterviewer.interviewerCode &&
                newInterviewer.interviewerName
              ) {
                setInterviewerList((prev) => [
                  ...prev,
                  {
                    ...newInterviewer,
                    interviewSequence: String(prev.length + 1),
                  },
                ]);

                // reset form
                setNewInterviewer({
                  interviewerCode: "",
                  interviewerName: "",
                  interviewerEmail: "",
                  interviewSequence: String(interviewerList.length + 1),
                  inputValue: "",
                });

                setShowAddInterviewer(false);
                setShowModal(true);
              } else {
                alert("Please enter a valid interviewer code.");
              }
            }}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};
export default ShortlistCandidates;
